/**
 * @generated SignedSource<<93ca3a8faa78b5a0ba2111be56faf95a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerLocalPickup_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"LocalPickupDescription_item">;
  readonly " $fragmentType": "BuyerLocalPickup_item";
};
export type BuyerLocalPickup_item$key = {
  readonly " $data"?: BuyerLocalPickup_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerLocalPickup_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerLocalPickup_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LocalPickupDescription_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "78852afc4151b22618630241b8348da8";

export default node;
